import { render, staticRenderFns } from "./com-about.vue?vue&type=template&id=0ca5a424&scoped=true&"
import script from "./com-about.vue?vue&type=script&lang=js&"
export * from "./com-about.vue?vue&type=script&lang=js&"
import style0 from "./com-about.vue?vue&type=style&index=0&id=0ca5a424&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca5a424",
  null
  
)

export default component.exports